"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
var _ = require("lodash");
var React = require("react");
var moment = require("moment");
var react_redux_1 = require("react-redux");
var react_toastify_1 = require("react-toastify");
var constants_1 = require("./constants");
var index_1 = require("../../model/index");
var formatter_1 = require("../../helpers/formatter");
var utils_1 = require("../_shared/worklogs/utils");
var OnlineTable_1 = require("../_shared/components/OnlineTable");
var FormComponent_1 = require("../_shared/components/inputs/FormComponent");
var constants_2 = require("../../constants");
var HOUR_ROW_WIDTH = 68;
var NAME_ROW_WIDTH = 150;
var CHECK_ROW_WIDTH = 96;
var Table = /** @class */ (function (_super) {
    __extends(Table, _super);
    function Table(props) {
        var _this = _super.call(this, props) || this;
        _this.fetchData = _.debounce(function (state, instance) {
            // show the loading overlay
            // fetch your data
            _this.props.getWeeklyWorkDays(_this.props.date.format(constants_2.DATE_FORMAT), instance.props.page, state.pageSize, state.filtered, state.sorted, _this.props.userStatus, _this.props.weekDayStatus, _this.props.approveStatus, _this.props.controlStatus, _this.props.userRole);
        }, 500);
        _this.state = { acceptUsers: [], viewUsers: [], controlUsers: [], filterEnabled: false, pages: -1, filtered: [] };
        return _this;
    }
    Table.prototype.componentWillReceiveProps = function (newProps) {
        var _a = this.table.state, page = _a.page, pageSize = _a.pageSize, filtered = _a.filtered, sorted = _a.sorted;
        var _b = this.props, weekNumber = _b.weekNumber, userStatus = _b.userStatus, userRole = _b.userRole, weekDayStatus = _b.weekDayStatus, approveStatus = _b.approveStatus, controlStatus = _b.controlStatus;
        if (weekNumber !== newProps.weekNumber ||
            userStatus !== newProps.userStatus ||
            userRole !== newProps.userRole ||
            weekDayStatus !== newProps.weekDayStatus ||
            approveStatus !== newProps.approveStatus ||
            controlStatus !== newProps.controlStatus) {
            this.setState({ acceptUsers: [], viewUsers: [], controlUsers: [] });
            this.props.getWeeklyWorkDays(newProps.date.format(constants_2.DATE_FORMAT), page, pageSize, filtered, sorted, newProps.userStatus, newProps.weekDayStatus, newProps.approveStatus, newProps.controlStatus, newProps.userRole);
        }
    };
    Table.prototype.renderCheckBoxColumn = function (key, weekDays) {
        var _this = this;
        var getPermissionAttrs = function () {
            var disabled = key !== 'viewUsers';
            var checked = (_this.state)[key].findIndex(function (s) { return s === weekDays.user._id; }) !== -1;
            if (key === 'acceptUsers') {
                checked = weekDays.is_approved || checked;
                disabled = weekDays.is_approved;
            }
            if (key === 'controlUsers') {
                checked = weekDays.is_controlled || checked;
                disabled = weekDays.is_controlled;
            }
            return { checked: checked, disabled: disabled };
        };
        return (React.createElement("div", { className: "center" },
            React.createElement("input", __assign({}, getPermissionAttrs(), { name: key, value: weekDays.user._id, type: "checkbox", onChange: function (event) { return _this.props.onSelectUsers(key, _this.handleCheckBox(event.target)); } }))));
    };
    Table.prototype.renderSelectAll = function (key) {
        var _this = this;
        return (React.createElement("div", { className: "center" },
            React.createElement("input", { name: key, type: "checkbox", checked: this.state[key].length === this.props.weekDays.length, onChange: function (event) {
                    var ids = [];
                    _this.props.weekDays.forEach(function (week) {
                        if (key === 'viewUsers' || !week.is_approved) {
                            ids.push(week.user._id);
                        }
                    });
                    if (_.isEmpty(ids)) {
                        react_toastify_1.toast.warn('Er zijn geen uren om goed te keuren');
                    }
                    else {
                        _this.props.onSelectUsers(key, _this.handleSelectAll(ids)(event.target));
                    }
                } })));
    };
    Table.prototype.getTotalColumns = function () {
        var calculateHours = function (workWeek) {
            var totalHours = (0, utils_1.getProjectHours)([]);
            _.forEach(workWeek.workDays, function (workDay) {
                var projectHours = (0, utils_1.getProjectHours)(workDay.worklogs);
                totalHours.work.approvedHours += projectHours.work.approvedHours;
                totalHours.travel.approvedHours += projectHours.travel.approvedHours;
                totalHours.special.approvedHours += projectHours.special.approvedHours;
            });
            return totalHours;
        };
        return [
            {
                Header: React.createElement("div", { className: "hour-header" }, constants_1.HOURS_MAP.WORK),
                headerClassName: 'left-border',
                id: constants_1.HOURS_MAP.WORK + 'total',
                accessor: function (w) {
                    return (React.createElement("span", { className: w.work_time_is_valid ? '' : 'error' }, formatter_1.Hour.durationToHourMinuteString(calculateHours(w).work.approvedHours)));
                },
                width: HOUR_ROW_WIDTH,
                sortable: false,
                className: 'left-border',
            },
            {
                Header: React.createElement("div", { className: "hour-header" }, constants_1.HOURS_MAP.TRAVEL),
                id: constants_1.HOURS_MAP.TRAVEL + 'total',
                accessor: function (w) {
                    return (React.createElement("span", { className: w.travel_time_is_valid ? '' : 'error' }, formatter_1.Hour.durationToHourMinuteString(calculateHours(w).travel.approvedHours)));
                },
                width: HOUR_ROW_WIDTH,
                sortable: false,
            },
            {
                Header: React.createElement("div", { className: "hour-header" }, constants_1.HOURS_MAP.SPECIAL),
                id: constants_1.HOURS_MAP.SPECIAL + 'total',
                accessor: function (w) {
                    return (React.createElement("span", { className: w.extra_time_is_valid ? '' : 'error' }, formatter_1.Hour.durationToHourMinuteString(calculateHours(w).special.approvedHours)));
                },
                width: HOUR_ROW_WIDTH,
                sortable: false,
            },
        ];
    };
    Table.prototype.getWorkDayColumns = function (date) {
        return [
            {
                Header: React.createElement("div", { className: "hour-header" }, constants_1.HOURS_MAP.WORK),
                headerClassName: 'left-border',
                id: constants_1.HOURS_MAP.WORK + date,
                accessor: function (w) {
                    var workDay = w.workDays.find(function (workDay) { return workDay.date === date; });
                    if (!workDay) {
                        return;
                    }
                    var cellClass = '';
                    cellClass += workDay.is_closed ? 'day-closed ' : '';
                    cellClass += workDay.work_time_is_valid ? '' : 'error';
                    var projectHours = (0, utils_1.getProjectHours)(workDay.worklogs);
                    return (React.createElement("span", { className: cellClass }, formatter_1.Hour.durationToHourMinuteString(projectHours.work.approvedHours)));
                },
                width: HOUR_ROW_WIDTH,
                sortable: false,
                className: 'left-border',
            },
            {
                Header: React.createElement("div", { className: "hour-header" }, constants_1.HOURS_MAP.TRAVEL),
                id: constants_1.HOURS_MAP.TRAVEL + date,
                accessor: function (w) {
                    var workDay = w.workDays.find(function (workDay) { return workDay.date === date; });
                    if (!workDay) {
                        return;
                    }
                    var cellClass = '';
                    cellClass += workDay.is_closed ? 'day-closed ' : '';
                    cellClass += workDay.travel_time_is_valid ? '' : 'error';
                    var projectHours = (0, utils_1.getProjectHours)(workDay.worklogs);
                    return (React.createElement("span", { className: cellClass }, formatter_1.Hour.durationToHourMinuteString(projectHours.travel.approvedHours)));
                },
                width: HOUR_ROW_WIDTH,
                sortable: false,
            },
            {
                Header: React.createElement("div", { className: "hour-header" }, constants_1.HOURS_MAP.SPECIAL),
                id: constants_1.HOURS_MAP.SPECIAL + date,
                accessor: function (w) {
                    var workDay = w.workDays.find(function (workDay) { return workDay.date === date; });
                    if (!workDay) {
                        return;
                    }
                    var cellClass = '';
                    cellClass += workDay.is_closed ? 'day-closed ' : '';
                    cellClass += workDay.extra_time_is_valid ? '' : 'error';
                    var projectHours = (0, utils_1.getProjectHours)(workDay.worklogs);
                    return (React.createElement("span", { className: cellClass }, formatter_1.Hour.durationToHourMinuteString(projectHours.special.approvedHours)));
                },
                width: HOUR_ROW_WIDTH,
                sortable: false,
            },
        ];
    };
    Table.prototype.render = function () {
        var _this = this;
        var userWeek = _.maxBy(this.props.weekDays, function (week) { return week.workDays.length; });
        var weekDayColumns = userWeek && _.map(userWeek.workDays, function (workDay) {
            return {
                Header: moment(workDay.date).format(constants_2.DISPLAY_WEEKDAY_DATE_FORMAT),
                headerClassName: 'left-border',
                columns: _this.getWorkDayColumns(workDay.date),
            };
        });
        var columns = __spreadArray([
            {
                Header: constants_1.HOURS_MAP.VIEW,
                columns: [{
                        Header: this.renderSelectAll('viewUsers'),
                        id: constants_1.HOURS_MAP.VIEW,
                        Cell: function (props) { return _this.renderCheckBoxColumn('viewUsers', props.original); },
                        width: CHECK_ROW_WIDTH,
                        sortable: false,
                    }],
            },
            {
                Header: constants_1.HOURS_MAP.CONTROL,
                columns: [{
                        Header: this.renderSelectAll('controlUsers'),
                        headerClassName: 'left-border',
                        id: constants_1.HOURS_MAP.CONTROL,
                        Cell: function (props) { return _this.renderCheckBoxColumn('controlUsers', props.original); },
                        width: CHECK_ROW_WIDTH,
                        sortable: false,
                        className: 'left-border',
                    }],
            },
            {
                Header: constants_1.HOURS_MAP.APPROVE,
                headerClassName: 'left-border',
                columns: [{
                        Header: this.renderSelectAll('acceptUsers'),
                        headerClassName: 'left-border',
                        id: constants_1.HOURS_MAP.APPROVE,
                        Cell: function (props) { return _this.renderCheckBoxColumn('acceptUsers', props.original); },
                        width: CHECK_ROW_WIDTH,
                        sortable: false,
                        className: 'left-border',
                    }],
            },
            {
                Header: constants_1.HOURS_MAP.WORKER,
                headerClassName: 'left-border',
                columns: [{
                        Header: function (props) {
                            return React.createElement("span", { id: "search", onClick: function () {
                                    _this.setState({
                                        filterEnabled: !_this.state.filterEnabled,
                                        filtered: _this.state.filterEnabled ? [] : _this.state.filtered
                                    });
                                } }, "Zoeken");
                        },
                        headerClassName: 'left-border',
                        id: constants_1.HOURS_MAP.WORKER,
                        accessor: function (w) { return (0, index_1.getUserFullName)(w.user); },
                        width: NAME_ROW_WIDTH,
                        filterable: this.state.filterEnabled,
                        className: "left-border",
                        sortable: false,
                    }],
            },
            {
                Header: constants_1.HOURS_MAP.TOTAL,
                headerClassName: 'left-border',
                columns: this.getTotalColumns(),
                className: 'left-border',
            }
        ], weekDayColumns || [], true);
        return (React.createElement(OnlineTable_1.default, { defaultPageIndex: parseInt(localStorage.getItem('page'), 10) || this.props.defaultPageIndex, defaultPageSize: parseInt(localStorage.getItem('pageSize'), 10) || OnlineTable_1.DEFAULT_PAGE_SIZE, ref: function (ref) { return _this.table = ref; }, data: this.props.weekDays, columns: columns, resizable: false, sortable: true, total: this.props.weekDays.length * this.props.pages, pages: this.props.pages, showPagination: true, showPageSizeOptions: true, className: "-striped -highlight", filterText: '', filtered: this.state.filtered, onFilteredChange: function (filtered) { _this.setState({ filtered: filtered }); }, onPageSizeChangeCallback: this.props.onPageSizeChangeCallback, manual: true, onFetchData: function (state, instance) { return _this.fetchData(state, instance); }, getTrProps: function (state, rowInfo) {
                var _a, _b, _c, _d;
                if (state === void 0) { state = null; }
                var original = (_a = rowInfo === null || rowInfo === void 0 ? void 0 : rowInfo.original) !== null && _a !== void 0 ? _a : {};
                var hasApprovalError = ((_b = original === null || original === void 0 ? void 0 : original.workWeek) === null || _b === void 0 ? void 0 : _b.hasOwnProperty('has_approval_error')) ?
                    (_c = original === null || original === void 0 ? void 0 : original.workWeek) === null || _c === void 0 ? void 0 : _c.has_approval_error : false;
                var isActive = (_d = original === null || original === void 0 ? void 0 : original.user) === null || _d === void 0 ? void 0 : _d.isActive;
                return {
                    className: "".concat(isActive ? 'active' : 'inactive').concat(hasApprovalError && isActive ? ' has-error' : '')
                };
            } }));
    };
    return Table;
}(FormComponent_1.default));
exports.Table = Table;
var mapStateToProps = function (_) {
    return {
        weekApi: _.reducer.api.weekOverview,
    };
};
var mapDispatchToProps = function (dispatch) { return ({}); };
var mergeProps = function (stateProps, dispatchProps, ownProps) {
    return __assign(__assign(__assign({}, stateProps), dispatchProps), ownProps);
};
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps, mergeProps)(Table);
